// leftTrim :: String -> String
function leftTrim(str) {
  return str.replace(/^\s*/, ``);
}

// trimValue :: a -> a
export default function trimValue(value = ``) {
  return typeof value === `string` ? leftTrim(value) : value;
}
